import { Edu } from '../types';

export const myEdu: Edu[] = [
  {
    title: "Master's Degree",
    qualification: 'Master of Science in Information Systems and Technologies',
    qualificationProfile: 'Electronic Business',
    form: 'Full-time',
    org: 'Novosibirsk State University of Economics and Management',
    orgSite: 'https://nsuem.ru/',
    from: '2016',
    to: '2018',
    location: 'Novosibirsk, Russia',
    achievements: ['Honours degree (Graduated with distinction)'],
  },
  {
    title: "Bachelor's Degree",
    qualification: 'Bachelor of Science in Fundamental Informatics and IT',
    qualificationProfile: 'Software Engineering',
    form: 'Full-time',
    org: 'Novosibirsk State University of Economics and Management',
    orgSite: 'https://nsuem.ru/',
    from: '2012',
    to: '2016',
    location: 'Novosibirsk, Russia',
    achievements: [
      'Honours degree (Graduated with distinction)',
      'Nomination "The Most Technological Project" at the Exhibition of Web Technologies for Business at NSUEM in 2016',
    ],
  },
];
